import React, { useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './ResetPassword.css';
import logo from '../assets/img/theme/tzone-logo-450x200.png';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useI18n, useTranslation } from '../i18n';
import API_BASE_URL from '../config/api';


const ResetPassword = () => {
  const { token } = useParams();
  const { t } = useTranslation();
  const { language } = useI18n();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${API_BASE_URL}/auth/reset-password/${token}`,
		
        { password },
        { headers: { 'Accept-Language': language } }
      );
      setMessage(t('resetPassword.success'));
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    } catch (error) {
      setMessage(error.response?.data?.error || t('resetPassword.error'));
    }
  };

  return (
    <div className="reset-password-container">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <LanguageSwitcher dark />
      </div>

      <div className="reset-password-logo">
        <img src={logo} alt="TZone Logo" />
      </div>
      <form className="reset-password-form" onSubmit={handleSubmit}>
        <h2>{t('resetPassword.title')}</h2>
        <label>{t('common.newPassword')}:</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <button type="submit">{t('resetPassword.submit')}</button>
        {message && <p>{message}</p>}
      </form>
    </div>
  );
};

export default ResetPassword;
